<div class="content">
  <mat-card>
    <mat-card-content>
      <p [innerHTML]="'detachedAccount' | translate"></p>
    </mat-card-content>
  </mat-card>
</div>
